import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import LabelGenBulkLabelGenerationContainer from '../../../components/componentsLabelGeneration/LabelGenBulkLabelGeneration/LabelGenBulkLabelGenerationContainer';


class labelGenBulkLabelGenerationView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <LabelGenBulkLabelGenerationContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default labelGenBulkLabelGenerationView;
